<template>
  <div class="video-details por" v-if="isShow" @click="clickPage">
    <div class="video-box por" ref="videoBox">
      <div class="video-box-content fixed-width flex aic">
        <!-- 播放器 -->
        <div class="video-box-content-item por" :style="{'width': showFullScreen ? '100%' : '860px'}" @click.stop="clickVideo">
          <video-box default-full-screen :resource-info="videoInfo" :video-src="videoUrl" :resize="showFullScreen" :poster="poster" @ctr-callback="ctrCallback" @change-clear="changeClear" :videoIsfcous="videoIsfcous" :rid="classId" :cid="cid" @ended="playEnded" @play="playVideo" @load="loadVideo" @ready="readyVideo" :is-play-end="isPlayEnd" :not-next="notNext" @full-screen="changeFullScreen" @rePlayVideo="rePlayVideo" ref="Video">
          </video-box>
          <div class="poa arrow-box video-icon  zi10 csp" :class="showFullScreen ? 'left_arrow' : 'right_arrow' " @click="showFullScreen = !showFullScreen">
          </div>
          <!-- <div class="end-box poa w100 h100 t0 l0 flex-col aic jcc lh1" v-if="isPlayEnd">
            <p class="fs16 tac end-text">当前课程已完成学习。</p>
            <mine-no-data hidden-text title="为您推荐" :image-width="160" :image-height="94" :width="160"></mine-no-data>
          </div> -->
          <div class="loading-box poa w100 h100 t0 l0" v-if="isLoading">
            <df-loading></df-loading>
          </div>
        </div>
        <!-- 右边信息栏 -->
        <div class="course-box ova por" v-show="!showFullScreen">
          <div class="poa mask-box zi1">
            <div class="course-box-header flex aic jcb ">
              <p class="fs20 course-box-title wot1">{{courseInfo.name | filterTitle}}</p>
              <div class="video-icon collection_icon csp collection-box" :class="{'collection_icon_active':courseInfo.is_collection}" @click="changeCourseCollectoin">
              </div>
            </div>
            <!-- 分页 -->
            <div class="course-box-curr flex " v-if="currList.length">
              <div :style="{height: (status ? domHeight : mrHieght) + 'px'}" class="ovh course-box-content lh1" :class="{'mb_16': status}">
                <div ref="currList">
                  <span v-for="(item,i) in currList" :key="item.curr" class="course-box-curr-item csp dib" :class="{'course-box-curr-active':currValue === item.curr}"
                    @click="changeCurr(item,1,i)">{{item.value}}</span>
                </div>
              </div>
              <p class="csp course-box-curr-more flex" v-if="isShowMore" @click="status = !status">
                <span class="dib" :class="{'course-box-curr-active':classText !== '更多课时'}">{{classText}}</span>
                <span class="video-icon dib vam" :class="status ? 'top_arrow': 'bottom_arrow'"></span>
              </p>
            </div>
          </div>
          <!-- 课时列表 -->
          <div class="ova list-box por" :style="{marginTop: (currList.length ? 127 : 80) + 'px',height: (currList.length ? 350 : 404) + 'px'}">
            <play-list :total="courseTotal" :getData="getCourseList" :curr="curr" @inner-curr-change="innerCurrChange" ref="playList">
              <div slot-scope="{row,index}" class="flex aic jcb list-item w100" :class="{'list-item-active':classId === row.id}" @click="changeClass(row,index)">
                <div class="flex aic">
                  <div class="video-icon play_icon pr10" v-if="classId === row.id"></div>
                  <p class="w100 csp wot1">{{row.name}}</p>
                </div>
                <div v-if="classId === row.id"><img src="@/assets/images/details/play.gif" alt="" /></div>
                <div class="video-icon lock_icon" v-else-if="+row.is_pay !== 1 &&  +row.is_free !== 2"></div>
              </div>
            </play-list>
          </div>
        </div>
      </div>
      <div class="fixed-width info-box flex aic jcb">
        <div class="info-box-content">
          <p class="fs20 info-box-name">{{courseInfo.name | filterTitle}}- {{videoInfo.name}}</p>
          <div class=" flex aic pt15">
            <template v-for="(item,i) in labelList">
              <p class="flex aic pr34" :key="i" v-if="item.show">
                <span class="video-icon  pr5 " :class="item.icon"></span>
                <span class="info-box-text">{{item.label}}</span>
                <span class="info-box-text">{{item.value}}</span>
              </p>
            </template>
          </div>
        </div>
        <!-- 开通会员 -->
        <div class="vip-btn flex aic jcc csp por lh1" @click="ShowVip()" v-if="+courseType === 2">
          <p class="flex aic fs18 vip-btn-text"><span class="video-icon vip_icon dib pr10"></span>{{courseInfo.is_pay
            === 1 ? '续费会员' : '开通会员'}}</p>
          <div class="vip-btn-tip poa l0" :class="vipInfo.discount ? 'zk-color' : 'lj-color'" v-if="(+vipInfo.real_price !== +vipInfo.price)">
            <p class="" v-if="vipInfo.discount">限时{{vipInfo.discount * 10}}折</p>
            <p class="" v-else>限时立减￥{{(vipInfo.price - vipInfo.real_price).toFixed(2)}}</p>
          </div>
        </div>
        <!-- 付费按钮 -->
        <div class="pay por lh1 flex-col aic jcc csp" v-else-if="+courseType === 3">
          <template v-if="courseInfo.price">
            <!-- 购买前 -->
            <template v-if="!courseInfo.is_pay">
              <div class="flex aic pay-btns" v-if="!userInfo.is_web_vip && !courseInfo.is_activity">
                <p class="pay-btns-vip tac" @click="changePay('vip')"><span class="pr5">开通会员</span><span>{{courseInfo.vip_price}}元购买</span>
                </p>
                <p class="pay-btns-price tac" @click="changePay('price')"><span class="pr5">{{courseInfo.price}}元</span>原价购买
                </p>
              </div>
              <template v-else>
                <div class="pay-btn por flex aic jcc" @click="changePay('price')">
                  <p class="pay-btn-text tac">
                    <span v-show="courseInfo.is_activity">￥</span>
                    <span>{{userInfo.is_web_vip ? courseInfo.vip_price : courseInfo.price}}元</span>
                    <span v-if="!courseInfo.is_activity">购买</span>
                    <s class="fs12 pl10" v-else>原价￥{{userInfo.is_web_vip ? courseInfo.original_vip_price :
                    courseInfo.original_price}}</s>
                  </p>
                  <div class="pay-btn-tip poa l0" :class="courseInfo.discount ? 'zk-color' : 'lj-color'" v-if="courseInfo.is_activity">
                    <p class="" v-if="courseInfo.discount">限时{{courseInfo.discount}}折</p>
                    <p class="" v-else>限时立减￥{{userInfo.is_web_vip ? (courseInfo.original_vip_price -
                    courseInfo.vip_price).toFixed(2) : (courseInfo.original_price - courseInfo.price).toFixed(2)}}</p>
                  </div>
                  <div class="pay-times fs12 poa" v-if="courseInfo.is_activity">
                    <p v-if="!courseInfo.activity_data.surplus_time">
                      活动结束时间：{{Tools.formatDate(courseInfo.activity_data.end_time, 'Y年MM月DD日')}}</p>
                    <p v-else v-html="`距活动结束：${surplus_time}`"></p>
                  </div>
                </div>

              </template>
            </template>
            <!-- 购买后 -->
            <template v-else-if="courseInfo.status !== 2">
              <div class="pay-renew flex-col aic jcc">
                <p class="pay-past">课程有效期至：{{courseInfo.past_time}}</p>
                <p class="pay-buy tac csp fs12" @click="changePay('price')">立即续费</p>
              </div>
            </template>
          </template>
        </div>
        <!-- 免费显示 -->
        <div v-else>
          <div class="free-box por">
            <p class="poa download-app fs12 tac csp" @click="goDownloadApp">下载APP</p>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box fixed-width flex">
      <div class="left-box">
        <!-- 选项卡 -->
        <div class="tabs-box flex aic w100 zi10">
          <template v-for="(item,i) in tabsList">
            <p v-if="item.show" :key="i" class="tabs-box-item csp" :class="{'tabs-box-active':tabsValue === item.value }" @click="changeTabs(item)">{{item.label}}</p>
          </template>
        </div>
        <div style="paddingTop:24px;"></div>
        <!-- 课时列表 -->
        <template v-if="tabsValue === 'list'">
          <div class="curr-box flex aic fww" v-if="currTotalList.length">
            <p v-for="val in currTotalList" :key="val.curr" class="curr-box-item tac fs16 csp" :class="{'curr-box-active':classCurr === val.curr}" @click="changeCurr(val,2)">{{val.value}}</p>
          </div>
          <div class="flex aic fww card-box">
            <course-card v-for="(item,i) in classList" :key="i" :item="item" image-width="202" image-height="114" width="202" imgKey="bigimg" class="card-box-item"
              :class="{'card-box-active':classId === item.id}" @detail="changeClass" :label-type="item.is_pay === 1 || item.is_free === 2 ? 'false' : ['', 'false', 'vip', 'pay'][item.type]" row="2">
            </course-card>
          </div>
        </template>
        <!-- 课程介绍 -->
        <template v-else-if="tabsValue === 'introduce'">
          <div class="introduce-box">
            <p class="fs16 introduce-box-text">{{courseInfo.remark}}</p>
            <div class="introduce-box-img" v-if="courseInfo.vertical_img && courseInfo.vertical_img.length">
              <img :src="img.show" alt="" v-for="(img,i) in courseInfo.vertical_img" :key="i" class="w100 vam">
            </div>
          </div>
        </template>
        <!-- 任课教师 -->
        <template v-else>
          <div class="teacher-box w100">
            <!-- 教师列表 -->
            <div class="flex aic pb20 teacher-box-list" :class="{'jcc': teacherTotal > 3}">
              <div class="video-icon big_left_arrow mr20 csp" v-if="!!beformValue" @click="changeTeacher('beform')"></div>
              <div class="all-teacher ovh">
                <div ref="allTeacher" class="all-teacher-content flex aic" :style="{transform:'translateX(' + xWidth + 'px)'}">
                  <div v-for="(item,i) in teacherList" :key="i" class="teacher-box-content flex aic mr15 csp" @mouseenter="changeMouseEvent(item,i)"
                    @click="OpenRouter(`/home/teacher/detail/${item.teacher_id}`)" :class="{'teacher-box-active':teacherIndex === i}">
                    <div class="teacher-box-img mr10 ovh">
                      <img :src="item.teacher_bigimg" v-df-avatar="defaultTeacherImg" alt="" class="w100">
                    </div>
                    <div>
                      <p class="fs18 teacher-box-name">{{item.teacher_name}}</p>
                      <div class="flex aic fs12">
                        <p class="csp flex aic" @click.stop="changeFollow(item)">
                          <span class="video-icon heart_icon mr2 dib pb2"></span>
                          <span class="teacher-box-follow">{{item.is_follow ? '已关注' : '关注'}}</span>
                        </p>
                        <p class="flex aic" v-show="item.follow_num">
                          <span class="teacher-box-dot dib"></span>
                          <span class="teacher-box-count">{{item.follow_num}}粉丝</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="video-icon big_right_arrow ml20 csp" v-if="!!afterValue" @click="changeTeacher('after')"></div>
            </div>
            <!-- 教师简介 -->
            <div class="teacher-box-introduce">
              <p class="fs18 teacher-box-title pb15">教师简介</p>
              <div class="flex aic">
                <p class="teacher-box-zhicheng">
                  <span class="video-icon zhicheng_icon mr5"></span>
                  <span>{{  teacherInfo.zhicheng || '优秀教师' }}</span>
                </p>
                <template v-if="teacherInfo.personality_label && teacherInfo.personality_label.length">
                  <p v-for="(label,i) in teacherInfo.personality_label" :key="i" class="teacher-box-personality" :class="'teacher-box-personality-' + (i%3)">{{label}}</p>
                </template>
              </div>
              <p class="teacher-box-desc">{{teacherInfo.content}}</p>
            </div>
            <!-- 教师课程 -->
            <template v-if="teacherInfo.course_list && teacherInfo.course_list.length">
              <div class="flex aic jcb pb15">
                <p class="fs18 teacher-box-title flex aic">教授课程 <span class="fs14 dib teacher-box-label">共{{teacherInfo.course_list.length}}个课程</span>
                </p>
                <p class="teacher-box-see flex aic csp" v-if="teacherInfo.course_list.length > 5" @click="OpenRouter(`/home/teacher/detail/${teacherId}`)">查看全部<span
                    class="video-icon new_bottom_arrow ml5 pb2"></span></p>
              </div>
              <div class="flex teacher-box-course w100">
                <course-card v-for="(item,i) in teacherInfo.course_list.slice(0, 5)" :key="i" :item="item" image-width="149" image-height="170" width="149" imgKey="bgimg" class="teacher-box-item"
                  @detail="changeJumpEvent(item)" is-custom-label>
                </course-card>
              </div>
            </template>
          </div>
        </template>
      </div>
      <div class="right-box flex-1">
        <p class="fs24 pb25 pt15">最新推荐</p>
        <div>
          <course-card v-for="(item,i) in recommendList" :key="i" :item="item" image-width="158" image-height="94" imgKey="bigimg" flex="flex" class="recommend-course" @detail="changeJumpEvent(item)"
            :showProps="`name,${item.type === 3 ? 'buy_num,price':''}`" :row="2" is-custom-label>
          </course-card>
        </div>
      </div>
    </div>
  </div>
  <offline v-else :is-no-data="!classList.length" show class="no-data"></offline>
</template>

<script>
import Mixins from '@/mixins/mixins'
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "VideoDetails",
  mixins: [Mixins.MakeRoute({ cid: 'cid', tab: 'courseType' }, 'params'), Mixins.MakeRoute(['subject_id', 'rid'], 'query')],
  filters: {
    filterTitle (text) {
      text = text ? text.split(/[:：]/) : '';
      return text[1] || text[0];
    }
  },
  data () {
    return {
      mrHieght: 13,
      domHeight: '',
      status: false,
      isShowMore: false,
      currList: [],   // 分页列表
      currTotalList: [],
      courseTotal: 0,
      curr: 1,
      currValue: 1,
      courseList: [], // 右边课时列表
      courseInfo: {},
      classId: '',    // 当前课时id
      classList: [],  // 下面课时列表
      videoUrl: '', // 视频
      videoInfo: {}, // 课时视频详情
      showFullScreen: false,
      tabsList: [
        { id: 1, label: '课程介绍', value: 'introduce', show: true },
        { id: 2, label: '课时列表', value: 'list', show: true },
        { id: 3, label: '任课教师', value: 'teacher', show: true },
      ],
      tabsValue: 'list',
      classCurr: 1,
      recommendList: [], // 推荐列表
      teacherList: [], // 教师列表
      teacherInfo: null,
      oldTeacherInfo: {},
      teacherTotal: 0, // 总的教师数量
      defaultTeacherImg: require('@/assets/images/details/default_avatar.png'),
      beformValue: 0,  // 前面教师列表
      afterValue: 0, // 后面教师列表
      xWidth: 0,
      vipInfo: {
        real_price: 0,
        price: 0
      },
      isPlayEnd: false, // 是否播放结束
      surplus_time: '',
      poster: '', // 视频封面图
      teacherIndex: 0, // 选中的教师下标
      teacherId: '',
      classText: '更多课时',
      isLoading: true,
      allClassList: [],
      isShow: true,
      isClickLock: false,
      notNext: false,
      isFullScreen: false,
			videoIsfcous:true, //是否焦点了视频,默认视频为焦点
			preventReClick:false,//防止暴力点击
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'currGrade', 'currTab', 'currAudio', 'isShowPayPopup']),
    subjectId () {
      let { currGrade } = this;
      let list = { 1: 325, 3: 332, 4: 333, 8: 326, 9: 327, 10: 328, 11: 329, 12: 330, 13: 331, 102: 423, 111: 424, 112: 425, 114: 422 };
      return list[+currGrade.pid !== 2 && +currGrade.pid !== 5 ? currGrade.pid : currGrade.id];
    },
    currProduct () {
      let tbxx = [8, 9, 10, 11, 12, 13].includes(this.currGrade.id);
      return tbxx ? 1 : 13;
    },
    labelList () {
      return [
        { label: '课时：', value: this.courseTotal, icon: 'classHour_icon', show: true },
        { label: '观看人数：', value: this.courseInfo.hits, icon: 'count_icon', show: !!this.courseInfo.hits },
        {
          label: '购买人数：',
          value: this.courseInfo.buy_num,
          icon: 'buy_icon',
          show: +this.courseType === 3 && !!this.courseInfo.buy_num
        },
      ]
    },
    classPlayRecord () {
      return +this.$route.query.rid || '';
    }
  },
  created () {
    this.setCurrAudio(null);
    this.initData();
    this.getVipInfo();
		// 从initData()中分离出来 不再每次路由改变时请求
		this.getCourseList();
		this.getCourseList(1, 28, false);
		// 从initData()中分离出来 end
  },
  watch: {
    $route (val) {
      this.initData();
    },
    currGrade () {
      this.getRecommendCourse();
    },
    currProduct (val) {
      this.getVipInfo();
    },
    courseInfo (val) {
      if (val) {
        // 当课程没有文字简介和没有图片详情时隐藏课程介绍
        let imgs = val.vertical_img.filter(e => e.show);
        if (!imgs.length && !val.remark) {
          this.tabsList.find(e => e.id === 1).show = false;
        }
      }
    },
    currValue (val) {
      if (+val <= 4) {
        this.classText = '更多课时';
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.currAudio) {
        this.GetAppAudio().audioInner.pause();
      }
    })
    this.getHeight();
  },
  methods: {
    ...mapMutations(['setCurrAudio','setCurrTab']),
    // 页面初始化
    initData () {
      // this.setCurrTab('parent'); // 防止 tab 选择错乱
      this.$emit('set-width', false);
      
      this.getRecommendCourse();
      this.getTeacherList();
    },
    goDownloadApp () {
      this.OpenRouter('/download');
    },
    // 触发付费弹窗
    async changePay (prop) {
			try{
			  let res = await this.checkClassState();
				this.ShowVip({ type: 'pay', cid: this.cid, checked: prop === 'vip' });
			} catch (error) {
			  if (+error.code === 20011) {
			    this.ShowToast('该课程已下架，请观看其他课程');
			    setTimeout(() => { window.close() }, 2500);
			  }
			  // this.$err(error);
			}	
    },
		//获取课程信息
		async checkClassState(){
			let params = {
				uid: this.userInfo.uid,
				course_id: this.cid,
				...this.Product,
				channel_type: 2,
				curr:1,
				limits:30,
				is_new: +this.courseType === 1 ? 1 : '',
				is_web: 1
			}
			let res = await this.http.getCourseList(params, { needCancel: 'left' });
			return res;
		},
    // 获取vip会员信息
    getVipInfo () {
      let params = {
        uid: this.userInfo.uid,
        product_id: this.currProduct,
        channel_id: 26,
        terminal_id: 3,
        channel_type: 2,
      };
      this.http.NEWGetVipList(params).then(res => {
        this.vipInfo = res.price_list.find(e => e.is_recommend === 1);
      }).catch(console.log);
    },
    // 推荐列表
    getRecommendCourse () {
      let params = {
        curr: 1,
        limits: 10,
        uid: this.userInfo.uid,
        subject_id: this.subject_id || this.subjectId,
        course_id: this.cid,
        ...this.Product,
				format_id:1,//限制获取的类型 1：视频，2：音频，3：富文本，4：游戏，7：flash游戏测试
        is_web: 1
      };
      this.http.NEWRecommendList(params).then(res => {
        this.recommendList = res.course_list.data;
      }).catch(this.$err);
    },
    // 获取播放视频
    getCourseVideo (id) {
      if (this.isClickLock) {
        return ;
      }
      this.isClickLock = true;
      let params = {
        uid: this.userInfo.uid,
        resources_id: id,
        prefix: 'aiapp',
        is_new: 1,
        ...this.Product,
        is_web: 1
      }
      this.http.getCourseVideoDetails(params, { needCancel: 'url' }).then(res => {
        if (+this.rid) {
          this.rid = id;
        }
        this.poster = res.bigimg;
        this.classId = id;
        this.videoInfo = res;
        this.videoUrl = res.video_gqurl;
        this.isPlayEnd = false;
      }).catch(err => {
        if (+err.code === 10020) {
          if (this.isShowPayPopup) {
            return;
          }
					if(this.isFullScreen){
						this.$refs.Video.fullScreen()
					}
          if (+this.courseType === 2) {
            if (this.userInfo.is_web_vip) {
              this.ShowGift({ type: 'no-power' });
            } else {
              this.ShowGift({ type: 'open-vip' });
            }
          } else if (+this.courseType === 3) {
            this.ShowGift({ type: 'pay', cid: this.cid ,'check-class':()=>{
								// 拦截当用户在详情页面的时候未购买的付费课程下架了点击续费能弹出购买页面
								this.$nextTick(async ()=>{
									try{
									  let res = await this.checkClassState();
										this.ShowVip({ type: 'pay', cid: this.cid });
									} catch (error) {
									  if (+error.code === 20011) {
									    this.ShowToast('该课程已下架，请观看其他课程');
									    setTimeout(() => { window.close() }, 2500);
											return false
									  }
									  // this.$err(error);
									}
								}) 
							},stop:true
						});
          }
					
        } else {
          this.$err(err);
        }
      }).finally(() => {
        setTimeout(() => { this.isClickLock = false; }, 1000);
      });
    },
    // 触发视频相应事件
    ctrCallback (type, ctr, key, i) {
      switch (type) {
        case 'next':
          // 下一集
          this.nextVideo('next');
          break;
      }
    },
    // 监听是否全屏
    changeFullScreen(bool){
      this.isFullScreen = bool;
    },
    readyVideo () {
      this.isLoading = false;
    },
    // 加载完视频播放
    loadVideo (video) {
      video.isZcl || video.play();
    },
    // 开始播放
    playVideo () {
      this.isPlayEnd = false;
    },
    // 播放结束
    playEnded (video) {
      this.nextVideo('end');
    },
		//重播
		rePlayVideo(){
			if(this.isPlayEnd){
				this.innerCurrChange(1);
				this.getCourseVideo(this.allClassList[0].id)
			}
		},
		clickPage(e){
			this.videoIsfcous = false;
		},
		clickVideo(){
			this.videoIsfcous = true;
		},
    // 播放下一个
    nextVideo (prop) {
      if (this.videoInfo.next_resource_id) {
        let index = this.allClassList.findIndex(e => e.id === this.videoInfo.next_resource_id)||this.classList.findIndex(e => e.id === this.videoInfo.next_resource_id);
        let item = this.allClassList.find(e => e.id === this.videoInfo.next_resource_id)||this.classList.find(e => e.id === this.videoInfo.next_resource_id);
        let pay = item.is_pay !== 0 || item.is_free === 2;
        if (pay && index !== -1 && !this.isFullScreen) {
          this.scrollEvent(item, index);
        }
        this.getCourseVideo(this.videoInfo.next_resource_id);
      } else {
        if(prop === 'next'){
          this.notNext = true;
          setTimeout(()=>{
            this.notNext = false;
          },2000)
        }else{
          this.isPlayEnd = true;
        }
      }
    },
    // 视频清晰度选择
    changeClear (prop) {
      let clear = { '标清': 'video_bqurl', '高清': 'video_gqurl', '超清': 'video_cqurl' }[prop];
      this.videoUrl = this.videoInfo[clear];
    },
    // 获取课程详情和课时列表
    async getCourseList (curr = 1, limits = 30, isScroll = true) {
      let params = {
        uid: this.userInfo.uid,
        course_id: this.cid,
        ...this.Product,
        channel_type: 2,
        curr,
        limits,
        is_new: +this.courseType === 1 ? 1 : '',
        is_web: 1
      }
      try {
        let res = await this.http.getCourseList(params, { needCancel: 'left' });
				if(res.module_id === 98){
					this.$emit('isTb')
				}
        if (!isScroll) {
          this.classList = res.resource_list.data;
          let total = res.resource_list.total;
          this.getClassTotal(28, total, 'currTotalList');
          if (!this.classId && this.classList.length) {
            let row = res.resource_list.data.find(e => +e.id === +this.rid) || '';
            this.getCourseVideo(row && +row.is_pay === 1 ? +this.rid : this.classList[0].id);
            // this.classId = +this.rid;
          }
        } else {
          document.title = this.$options.filters['filterTitle'](res.name);
          this.courseInfo = res;
          this.courseList = res.resource_list.data;
          this.courseTotal = res.resource_list.total || 0;
          if (!this.courseList.length) {
            return this.closePage();
          }
          if (res.activity_data && res.activity_data.surplus_time && res.is_activity && !this.surplus_time) {
            this.ActivityCountDown(res.activity_data.surplus_time * 1000, {
              key: 'surplus_time',
              format: 'DD天HH时mm分ss秒',
              style: 'color:#FFF000;'
            }, () => {
              this.getCourseList();
            });
          }
          this.getClassTotal(30, this.courseTotal, 'currList');
					if(+curr === 1){
						this.allClassList = '-'.repeat(this.courseTotal).split('').map(() => ({}));
					}
					
					this.allClassList.splice((curr - 1)*limits ,limits,...this.courseList)
     //      if(+curr === 1){
     //        this.allClassList = [];
     //      }
     //      this.allClassList.push(...this.courseList);
        }
        return this.courseList;
      } catch (error) {
        if (+error.code === 20011) {
          this.isShow = false;
          return this.closePage();
        }
        this.$err(error);
      }
    },
    closePage(){
      this.ShowToast('内容正在制作，请观看其他课程');
      setTimeout(() => { window.close() }, 2500);
    },
    // 课时分页条数
    getClassTotal (limits, total, key) {
      if (total > limits && !this[key].length) {
        this[key] = [];
        let start = 0;
        for (let i = 1; start < total; i++) {
          this[key].push({
            value: start + 1 + '-' + Math.min((start += limits), total),
            curr: i
          });
        }
        this.getHeight();
      }
    },
    // 收藏课程
    changeCourseCollectoin () {
      if (!this.userInfo.uid) {
        return this.ShowToast('需要登录才能收藏课程!');
      }
      let params = {
        uid: this.userInfo.uid,
        course_id: this.cid,
        ...this.Product,
      };
      this.http.saveCourseCollection(params).then(res => {
        this.ShowToast(res.status === 1 ? '收藏成功' : '取消收藏');
        this.courseInfo.is_collection = res.status === 1 ? 1 : 0;
      }).catch(this.$err);
    },
    // 获取教师列表
    getTeacherList () {
      this.http.getTeacherList({
        uid: this.userInfo.uid,
        course_id: this.cid,
        is_new: 1,
        ...this.Product
      }).then(res => {
        this.teacherList = res.list;
        this.teacherTotal = res.total;
        this.afterValue = res.total > 3 ? res.total - 3 : 0;
        if (!this.teacherInfo && this.teacherList.length) {
          this.teacherId = this.teacherList[0].teacher_id;
          this.getTeacherDetails(this.teacherList[0].teacher_id);
        }
      }).catch(this.$err);
    },
    // 移动老师列表
    changeTeacher (prop) {
      let defaultWidth = 217;
      if (prop === 'beform') {
        this.xWidth += defaultWidth;
        this.beformValue--;
        this.afterValue++;
      } else {
        this.beformValue++;
        this.afterValue--;
        this.xWidth = -(this.beformValue * defaultWidth);
      }
    },
    // 获取老师详情
    getTeacherDetails (id) {
      this.http.NEWTeacherDetails({ id, uid: this.userInfo.uid, ...this.Product }).then(res => {
        this.teacherInfo = res.info;
        this.oldTeacherInfo[id] = res.info;
      }).catch(this.$err);
    },
    // 切换老师信息
    changeMouseEvent (item, index) {
      this.teacherIndex = index;
      this.teacherId = item.teacher_id;
      if (this.oldTeacherInfo[item.teacher_id]) {
        this.teacherInfo = this.oldTeacherInfo[item.teacher_id];
      } else {
        this.getTeacherDetails(item.teacher_id);
      }
    },
    // 课程切换
    changeJumpEvent (item) {
      let url = `/home/video/details/${item.id}/${item.type}`;
      if (this.subject_id) {
        url += `?subject_id=${this.subject_id}`;
      }
      this.OpenRouter(url);
    },
    // 切换卡片
    changeTabs (item) {
      this.tabsValue = item.value;
    },
    // 滚动到下一页
    innerCurrChange (curr) {
      this.curr = curr;
      this.currValue = curr;
      if (curr > 4) {
        this.classText = this.currList[curr-1].value;
      }
    },
    // 选择课时
    async changeClass (row, index = '') {
      if (this.classId === row.id && !this.isPlayEnd) {
        return;
      }
      if (this.isClickLock) {
        return this.ShowToast('当前正在加载中，请稍后再点');
      }
			try{
			  let res = await this.checkClassState();
				let pay = row.is_pay !== 0 || row.is_free === 2;
				if (typeof index === 'number' && pay) {
				  this.scrollEvent(row, index);
				}
				await this.getCourseVideo(row.id);
			} catch (error) {
			  if (+error.code === 20011) {
			    this.ShowToast('该课程已下架，请观看其他课程');
			    setTimeout(() => { window.close() }, 2500);
			  }
			  // this.$err(error);
			}
      
    },
    // 列表滚动
    scrollEvent (item, index) {
      let dom = this.$refs.playList;
      // let offsetTop = dom.$refs['item-' + index][0].offsetTop;
      // dom.scrollTo(offsetTop - 150, 16); //滚动到指定位置
			dom.$refs['item-' + index][0].scrollIntoView(false); //将指定位置移动到可视位置
      this.classId = item.id;
    },
    // 关注老师
    changeFollow (item) {
			if(this.preventReClick){
				return
			}
			this.preventReClick = true;
      let { Product, userInfo } = this;
      if (!userInfo.uid) {
        return this.ShowToast('需要登录才能关注!');
      }
      let params = {
        uid: userInfo.uid,
        teacher_id: item.teacher_id,
        ...Product,
      };
      this.http.NEWFollowTeacher(params).then(res => {
				this.preventReClick = false;
        this.ShowToast(+res.status === 1 ? '关注成功' : '取消关注');
        item.is_follow = +res.status === 1?true:false;
        if (item.is_follow) {
          item.follow_num++;
        } else {
          item.follow_num--;
        }
      }).catch(this.$err);
    },
    // 获取高度
    getHeight () {
      this.$nextTick(() => {
        let dom = this.$refs.currList;
        this.domHeight = dom ? dom.offsetHeight : '';
        this.isShowMore = this.domHeight - 16 > this.mrHieght + 10;
      });
    },
    // 点击分页
    changeCurr (item, prop, index) {
      if (prop === 1) {
        this.curr = item.curr;
        this.currValue = item.curr;
        if (index > 3) {
          this.classText = item.value;
        }
        this.status = false;
      } else {
        this.classCurr = item.curr;
        this.getCourseList(item.curr, 28, false);
      }
    }
  },
}
</script>

<style scoped lang="less">
@import '../../../../../assets/less/function.less';
@import '../../../../../assets/less/loops.less';

@act-color: #1177ff;
@df-color: #ffffff;
@text-color: #999fa6;

/deep/ .vjs-poster {
  background-size: 100% 100%;
  background-position: top left;
}

.video-icon {
  .spirit(url(../../../../../assets/images/video_icon.png));
  &.left_arrow {
    &:after {
      width: 12px;
      height: 48px;
      background-position: -342px -53px;
    }
  }
  &.left_arrow_hover {
    &:after {
      background-position: -324px -53px;
    }
  }
  &.right_arrow {
    &:after {
      width: 12px;
      height: 48px;
      background-position: -306px -53px;
    }
  }
  &.right_arrow_hover {
    &:after {
      background-position: -288px -53px;
    }
  }
  &.collection_icon {
    &:after {
      width: 32px;
      height: 32px;
      background-position: -11px -53px;
    }
  }
  &.collection_icon_active {
    &:after {
      background-position: -83.1px -53px;
    }
  }
  &.collection_icon_hover {
    &:after {
      background-position: -47px -53px;
    }
  }
  &.bottom_arrow {
    position: relative;
    margin-left: 2px;
    &:after {
      width: 9px;
      height: 5px;
      background-position: -123px -53px;
      position: absolute;
      top: 4px;
    }
  }
  &.bottom_arrow_hover {
    &:after {
      background-position: -123px -61px;
    }
  }
  &.top_arrow {
    position: relative;
    margin-left: 2px;
    &:after {
      width: 9px;
      height: 5px;
      background-position: -136px -53px;
      position: absolute;
      top: 4px;
    }
  }
  &.top_arrow_hover {
    &:after {
      background-position: -136px -61px;
    }
  }
  &.play_icon {
    &:after {
      width: 10px;
      height: 12px;
      background-position: -150px -53px;
    }
  }
  &.music_icon {
    &:after {
      width: 16px;
      height: 16px;
      background-position: -163px -53px;
    }
  }
  &.lock_icon {
    &:after {
      width: 16px;
      height: 16px;
      background-position: -181px -53px;
    }
  }
  &.classHour_icon {
    &:after {
      width: 22px;
      height: 22px;
      background-position: -199px -53px;
    }
  }
  &.count_icon {
    &:after {
      width: 22px;
      height: 22px;
      background-position: -223px -53px;
    }
  }
  &.buy_icon {
    &:after {
      width: 22px;
      height: 22px;
      background-position: -223px -76px;
    }
  }
  &.vip_icon {
    &:after {
      width: 22px;
      height: 22px;
      background-position: -366px -53px;
    }
  }
  &.heart_icon {
    &:after {
      width: 11px;
      height: 11px;
      background-position: -261px -53px;
    }
  }
  &.heart_icon_hover {
    &:after {
      background-position: -248px -53px;
    }
  }
  &.heart_icon_active {
    &:after {
      background-position: -274px -53px;
    }
  }
  &.zhicheng_icon {
    &:after {
      width: 26px;
      height: 24px;
      background-position: -10px -91px;
    }
  }
  &.new_bottom_arrow {
    transform: rotate(270deg);
    &:after {
      width: 14px;
      height: 8px;
      background-position: -39px -91px;
    }
  }
  &.new_bottom_arrow_hover {
    &:after {
      background-position: -55px -91px;
    }
  }
  &.big_right_arrow {
    &:hover {
      &::after {
        background-position: -199px -91px;
      }
    }
    &:after {
      width: 40px;
      height: 50px;
      background-position: -157px -91px;
    }
  }
  &.big_left_arrow {
    &:hover {
      &::after {
        background-position: -115px -91px;
      }
    }
    &:after {
      width: 40px;
      height: 50px;
      background-position: -73px -91px;
    }
  }
}

.video-details {
  background: #f5fcff;
  .fixed-width {
    width: 1196px;
    margin: 0 auto;
  }
  .video-box {
    line-height: 1;
    background: #191d23;
    padding-top: 24px;
  }
  .video-box-content {
    &-item {
      // height: 800px;
    }
    .arrow-box {
      top: 50%;
      right: -12px;
      transform: translateY(-50%);
    }
    .right_arrow:hover {
      .video-icon .right_arrow_hover;
    }
    .left_arrow:hover {
      .video-icon .left_arrow_hover;
    }
    .loading-box {
      padding: 122px 340px 0;
    }
    .end-box {
      padding: 0 86px;
      background: #000f22;
      z-index: 10;
      .end-text {
        color: @df-color;
        padding: 63px 0 59px;
      }
      /deep/ .mine-no-data {
        width: 688px;
        .user-df-title {
          color: rgba(255, 255, 255, 0.8);
          font-size: 16px;
          margin-bottom: 16px;
        }
        .detail-box {
          color: rgba(255, 255, 255, 0.8);
        }
        .course-card {
          margin-bottom: 20px;
        }
      }
    }
  }
  .course-box {
    width: 336px;
    height: 484px;
    background: #1f232a;
    color: #fff;
    scrollbar-width: none;
    &-header {
      padding: 24px 16px;
    }
    &-title {
      line-height: 32px;
      opacity: 0.9;
    }
    &-curr {
      width: 304px;
      margin-left: 16px;
      padding: 12px 0px 11px 9px;
      background: #2f343c;
      color: @text-color;
      border-radius: 4px;
      &-active {
        color: @df-color;
      }
      &-item {
        height: 12px;
        line-height: 12px;
        padding-right: 16px;
        margin-bottom: 16px;
        &:not(.course-box-curr-active) {
          &:hover {
            color: #fff;
          }
        }
      }
      &-more {
        &:hover {
          color: #cfcfcf;
          .bottom_arrow {
            .video-icon .bottom_arrow_hover;
          }
          .top_arrow {
            .video-icon .top_arrow_hover;
          }
        }
      }
    }
    &-content {
      width: 220px;
      transition: height 0.3s;
    }
    .mask-box {
      width: 336px;
      background: #1f232a;
    }
  }
  .collection-box {
    &:not(.collection_icon_active):hover {
      .video-icon .collection_icon_hover;
    }
  }
  .list-item {
    height: 40px;
    // line-height: 40px;
    line-height: 1.2;
    padding: 0 22px 0 24px;
    opacity: 0.6;
    &-active {
      background: @act-color;
      opacity: 1;
    }
    &:hover {
      opacity: 1;
    }
  }
  .mb_16 {
    margin-bottom: -16px;
  }
  .pr34 {
    padding-right: 34px;
  }
  .info-box {
    padding: 20px 0 18px 0;
    line-height: 1;
    &-content {
      color: @df-color;
      width: 72%;
    }
    &-name {
      color: rgba(255, 255, 255, 0.9);
    }
    &-text {
      color: rgba(255, 255, 255, 0.6);
    }
    .free-box {
      width: 336px;
      height: 48px;
      background: url(../../../../../assets/images/details/free.png) no-repeat
        top left / 100%;
    }
    .download-app {
      bottom: 10px;
      right: 24px;
      width: 76px;
      height: 29px;
      line-height: 29px;
      border: 1px solid #9fc8ff;
      border-radius: 4px;
      color: #9fc8ff;
      &:hover {
        color: @act-color;
        border: 1px solid @act-color;
      }
    }
    .vip-btn {
      margin-right: 16px;
      width: 304px;
      height: 40px;
      border-radius: 8px;
      background: url(../../../../../assets/images/details/open.png) no-repeat
        top left / 100%;
      &:hover {
        background: url(../../../../../assets/images/details/open_hover.png)
          no-repeat top left / 100%;
      }
      &-text {
        font-weight: bold;
        color: #9b632c;
      }
      &-tip {
        color: @df-color;
        padding: 4px 12px;
        font-size: 12px;
        border-radius: 10px 10px 10px 0px;
        top: -12px;
      }
    }
    .lj-color {
      background: linear-gradient(90deg, #ff3b5f 0%, #ff1f48 100%);
    }
    .zk-color {
      background: linear-gradient(90deg, #ff8726 0%, #ff5724 100%);
    }
    .pay {
      font-size: 13px;
      &-renew {
        width: 336px;
      }
      &-past {
        color: #f5cf94;
        padding-bottom: 12px;
      }
      &-buy {
        width: 76px;
        line-height: 24px;
        background: linear-gradient(90deg, #ffd879, #ffe86a);
        border-radius: 12px;
        color: #825215;
      }
      &-times {
        color: rgba(255, 255, 255, 0.7);
        bottom: -20px;
      }
      &-btns {
        p {
          line-height: 34px;
          border-radius: 4px;
        }
        &-vip {
          width: 168px;
          background: linear-gradient(90deg, #ffd879, #ffe86a);
          color: #825215;
          &:hover {
            background: linear-gradient(90deg, #f0ca71, #f0db65);
          }
        }
        &-price {
          width: 150px;
          background: #262c36;
          border: 1px solid;
          border-color: linear-gradient(0deg, #ffd879, #ffe76a);
          color: #ffd878;
          margin-left: 16px;
          &:hover {
            background: #191d23;
          }
        }
      }
      &-btn {
        width: 304px;
        height: 34px;
        background: linear-gradient(90deg, #ffd879, #ffe86a);
        border-radius: 4px;
        margin-right: 16px;
        &:hover {
          background: linear-gradient(90deg, #f0ca71, #f0db65);
        }
        &-text {
          color: #825215;
        }
        &-tip {
          color: @df-color;
          padding: 4px 12px;
          font-size: 12px;
          border-radius: 10px 10px 10px 0px;
          top: -12px;
        }
      }
    }
  }
  .content-box {
    padding-top: 32px;
  }
  .right-box {
    padding-left: 23px;
    .recommend-course {
      margin-bottom: 16px;
      line-height: 1;
      /deep/ .vip {
        display: block;
      }
      /deep/ .detail-box {
        padding-left: 10px;
        .name {
          font-size: 16px;
        }
        .prop {
          padding-top: 8px;
        }
        .course-buy,
        .course-price,
        .course-hits {
          padding-top: 50px;
        }
      }
    }
  }
  .left-box {
    width: 857px;

    .tabs-box {
      font-size: 20px;
      color: #333f4e;
      position: sticky;
      top: 65px;
      background-color: #f5fcff;
      &-item {
        margin-right: 33px;
        padding: 12px 0;
        &:not(.tabs-box-active):hover {
          font-weight: bold;
          color: @act-color;
        }
        &::before {
          content: '';
          width: 0;
        }
      }
      &-active {
        font-weight: bold;
        color: @act-color;
        position: relative;
        &::before {
          content: '';
          width: 24px;
          height: 3px;
          background: @act-color;
          border-radius: 2px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          transition: width 0.3s ease-in-out 0s;
        }
      }
    }
    .curr-box {
      padding-bottom: 18px;
      &-item {
        padding: 0 12px;
        height: 24px;
        line-height: 24px;
        color: #666f7a;
        opacity: 0.7;
        border-radius: 12px;
        margin-right: 16px;
        margin-bottom: 10px;
        &:not(.curr-box-active):hover {
          color: @act-color;
        }
      }
      &-active {
        background: @act-color;
        opacity: 1;
        color: @df-color;
      }
    }
    .card-box {
      margin-left: -16px;
      &-item {
        margin-left: 16px;
      }

      /deep/ .card-box-active {
        .name {
          color: @act-color;
        }
      }
      /deep/ .vip {
        display: block;
      }
    }
    /deep/ .name {
      height: 48px;
      line-height: 24px;
      padding: 0;
      margin: 12px 0;
      font-size: 16px;
      box-sizing: content-box;
      // .wot2;
    }
  }
  .introduce-box {
    padding-bottom: 24px;
    &-text {
      color: #666f7a;
      line-height: 24px;
    }
    &-img {
      padding-top: 25px;
      margin: 0 auto;
      width: 750px;
    }
  }
  .teacher-box {
    background: @df-color;
    padding: 20px 24px 0;
    margin-bottom: 48px;
    &-list {
      border-bottom: 1px solid #eeeeee;
    }
    .all-teacher {
      width: 636px;
      &-content {
        transition: transform 0.3s;
      }
    }
    &-content {
      width: 202px;
      height: 84px;
      border-radius: 15px;
      padding: 14px 0 15px 16px;
      line-height: 1;
      flex-shrink: 0;
    }
    &-active {
      background: linear-gradient(70deg, #4e7ffc, #c261ff);
      .teacher-box-name,
      .teacher-box-follow,
      .teacher-box-count {
        color: @df-color;
      }
      .teacher-box-dot {
        background: @df-color;
      }
      .heart_icon {
        .video-icon .heart_icon_hover;
      }
    }
    &-name {
      color: @text-color;
      padding-bottom: 14px;
    }
    &-follow {
      color: @text-color;
    }
    &-img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
    }
    &-dot {
      width: 3px;
      height: 3px;
      background: @text-color;
      opacity: 0.7;
      border-radius: 50%;
      margin: 0 3px;
    }
    &-count {
      color: @text-color;
      opacity: 0.7;
    }
    &-introduce {
      padding: 24px 0 40px 0;
    }
    &-title {
      color: #333f4e;
    }
    &-zhicheng {
      padding-right: 16px;
      height: 24px;
      line-height: 24px;
      background: #ffe9ed;
      border-radius: 12px;
      color: #ff5776;
    }
    &-personality {
      padding: 0 16px;
      border-radius: 12px;
      margin-left: 16px;
      line-height: 24px;
      &-0 {
        background: #f8dbff;
        color: #d92dff;
      }
      &-1 {
        background: #fff3d7;
        color: #ff9500;
      }
      &-2 {
        background: #d0ffe8;
        color: #01c562;
      }
    }
    &-desc {
      padding-top: 15px;
      color: #666f7a;
      line-height: 22px;
    }
    &-label {
      padding-left: 18px;
      color: #666f7a;
    }
    &-see {
      color: #999fa6;
      &:hover {
        color: @act-color;
        .new_bottom_arrow {
          .video-icon .new_bottom_arrow_hover;
        }
      }
    }
    &-course {
      padding-bottom: 50px;
      margin-left: -16px;
      /deep/ .name {
        height: 28px;
        font-size: 16px;
        padding: 11px 0;
        margin-bottom: 16px;
      }
    }
    &-item {
      margin-left: 16px;
    }
  }
}
</style>